import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class AsnOrders_ds_get_licenseplates_by_shipmentId_or_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId?: number, ids?: number[] }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LocationId?: number, LookupCode?: string, NetWeight?: number, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_licenseplates_by_shipmentId_or_ids/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId?: number, ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LocationId?: number, LookupCode?: string, NetWeight?: number, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_licenseplates_by_shipmentId_or_ids/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId?: number, ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, GrossWeight?: number, LocationId?: number, LookupCode?: string, NetWeight?: number, StatusId?: number, Status?: { Name?: string }, Location?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/datasources/ds_get_licenseplates_by_shipmentId_or_ids/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentId?: number, ids?: number[]    }) {
      return false;
    }
}
